/**
 * BuildingLegend — on-map key decoding the building type → colour scheme.
 *
 * Buildings are coloured by type (OSM tags, or a curated `mnType` override);
 * unclassified `building=yes` footprints stay neutral slate. This legend is the
 * single visual key for that scheme. Collapsible to stay out of the way; only
 * mounted when the buildings layer is enabled (wired in App).
 */

import { BUILDING_LEGEND } from "../map/layers";
import { useT } from "../hooks/useLang";

const BUILDING_LABEL_TH: Record<string, string> = {
  Residential: "ที่อยู่อาศัย",
  Commercial: "พาณิชย์",
  Office: "สำนักงาน",
  Industrial: "อุตสาหกรรม",
  Government: "ราชการ",
  Police: "ตำรวจ",
  Fire: "ดับเพลิง",
  Hospital: "โรงพยาบาล",
  School: "โรงเรียน",
  Temple: "วัด",
  Mosque: "มัสยิด",
  Hotel: "โรงแรม",
  Unclassified: "ไม่ระบุ",
};

function swatchCss(color: [number, number, number]): string {
  return `rgb(${color[0]}, ${color[1]}, ${color[2]})`;
}

export function BuildingLegend() {
  const t = useT();
  return (
    <details className="building-legend" open>
      <summary className="mono">{t("BUILDING TYPES", "ประเภทอาคาร")}</summary>
      <div className="building-legend-grid">
        {BUILDING_LEGEND.map((row) => (
          <div key={row.label} className="building-legend-row">
            <span
              className="building-legend-swatch"
              style={{ background: swatchCss(row.color) }}
              aria-hidden="true"
            />
            <span className="building-legend-label mono">
              {t(row.label, BUILDING_LABEL_TH[row.label] ?? row.label)}
            </span>
          </div>
        ))}
      </div>
    </details>
  );
}
